type WordmarkContext='desktop-header'|'mobile-header'|'login-card'|'small-320';

const logoAssetUrl='/web/brand/profenz-logo.png';

export function ProFenzMark({context}:{context:WordmarkContext}){
  return <div
    className={`wordmark wordmark--${context}`}
    role="img"
    aria-label="ProFenz"
    data-profenz-mark-context={context}
  >
    <img className="wordmark-image" src={logoAssetUrl} alt="" aria-hidden="true"/>
  </div>;
}
